import {Switch} from "@/components/ui/switch";
import {useRouter} from "next/navigation";
import React, {useState} from 'react';

const FilterAvailable = () => {
    const [isAvailable, setIsAvailable] = useState<boolean>(false);
    const router = useRouter();

    const changeAvailableStatus = () => {
        setIsAvailable(!isAvailable);
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set('available', String(!isAvailable)); // Update availability in query
        router.push(`?${queryParams.toString()}`);
    };

    return (
        <div dir="ltr" className="flex justify-between items-center">
            <Switch
                checked={isAvailable}
                className="h-[28px]"
                onCheckedChange={changeAvailableStatus}
            />
            <span className="ml-2">موجود</span>
        </div>
    );
};

export default FilterAvailable;
